import { render, staticRenderFns } from "./SortSelect.vue?vue&type=template&id=405cea00&scoped=true"
import script from "./SortSelect.vue?vue&type=script&lang=js"
export * from "./SortSelect.vue?vue&type=script&lang=js"
import style0 from "./SortSelect.vue?vue&type=style&index=0&id=405cea00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405cea00",
  null
  
)

export default component.exports